import { consoleSandbox } from '@sentry/utils';

/**
 * This is a shim for the Replay integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove replay
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
class ReplayShim  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Replay';}

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   constructor(_options) {
    this.name = ReplayShim.id;

    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using new Replay() even though this bundle does not include replay.');
    });
  }

  /** jsdoc */
   setupOnce() {
    // noop
  }

  /** jsdoc */
   start() {
    // noop
  }

  /** jsdoc */
   stop() {
    // noop
  }

  /** jsdoc */
   flush() {
    // noop
  }
} ReplayShim.__initStatic();

export { ReplayShim as Replay };
//# sourceMappingURL=Replay.js.map
